import { render } from "./PlaybackVideo.vue?vue&type=template&id=495ec1a3&scoped=true"
import script from "./PlaybackVideo.vue?vue&type=script&lang=ts"
export * from "./PlaybackVideo.vue?vue&type=script&lang=ts"

import "./PlaybackVideo.vue?vue&type=style&index=0&id=495ec1a3&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-495ec1a3"

export default script